<script>
export default {
  name: 'UserStatus',
  props: {
    value: String,
    label: String,
  },
};
</script>

<template lang="pug">
  .status(:class="[value]") {{ label }}
</template>

<style scoped lang="scss">
.status {
  box-sizing: border-box;
  padding: 0 15px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 500;
  font-family: Geometria, sans-serif;
  font-size: 12px;
  font-style: normal;
  line-height: 12px;
  letter-spacing: 0.36px;
  width: 100%;
  color: rgba(255, 255, 255, 1);
}
.unconfirmed {
  background-color: rgba(255, 141, 76, 1);
}
.blocked {
  background-color: rgba(226, 229, 233, 1);
  color: rgba(146, 167, 176, 1);
}
.active {
  background-color: rgba(90, 193, 105, 1);
}
</style>
